import React from "react";
import Logo from '../../../icons/uae_dentist_logotypeLarge.png';
import './navigationbar.css'
import {
  Button,
  Navbar,
  NavDropdown,
  Nav,
  Image,
} from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap'
// import firebase from "firebase";


export default function Navigationbar() {

    // const [loggedIn, setLoggedIn] = useState(false);
    // const [username, setUsername] = useState('John Doe');


    // const firebaseLogin = () => {
    //     let base_provider = new firebase.auth.GoogleAuthProvider();
    //     firebase.auth().signInWithPopup(base_provider)
    //     .then((result) => {
    //         console.log(result)
    //         setUsername(result.user.displayName)
    //         setLoggedIn(true)
    //         console.log('Logged in with Google Successfully!')
    //     })
    //     .catch((error)=> {
    //         console.log(error)
    //         console.log('Google Login Failed!')
    //         setLoggedIn(false)
    //     })
    // }


    return (
    <div>
        <Navbar className=" " bg="light" expand="lg" style={{ borderColor: 'black'}}>
        
        <LinkContainer to="/">
        <Navbar.Brand>
            <Image className='p-1'src={Logo} style={{width: "70px", height: "50px"}} rounded></Image>
        </Navbar.Brand>
        </LinkContainer>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
            
            <NavDropdown title="For Dentists" id="basic-nav-dropdown">
            <LinkContainer to="/login">
                <NavDropdown.Item>Log In</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/register">
                <NavDropdown.Item>Join Today</NavDropdown.Item>
            </LinkContainer>

            <LinkContainer to="/for-dentists/super-practice">
                <NavDropdown.Item>Super Practice</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/for-dentists/patient-acquisition">
                <NavDropdown.Item>Patient Acquisition</NavDropdown.Item>
            </LinkContainer>
            </NavDropdown>
            
            <NavDropdown title="Company" id="basic-nav-dropdown">
            <LinkContainer to="/about-us">
                <NavDropdown.Item>About Us</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/careers">
                <NavDropdown.Item>Careers</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/support">
                <NavDropdown.Item>Support</NavDropdown.Item>
            </LinkContainer>
            </NavDropdown>

            {/* <LinkContainer to="/add-clinic">
                <Nav.Link>Add Clinic</Nav.Link>
            </LinkContainer> */}
            
            {/* <LinkContainer to="/behind-the-scenes">
                <Nav.Link>Behind the Scenes</Nav.Link>
            </LinkContainer> */}
            </Nav>
            {/* {loggedIn && 
            <p className="mx-auto" >Welcome {username}!</p>
            } */}

            {/* <Button onClick={firebaseLogin} variant="primary">User Log In</Button> */}

            <LinkContainer className="mx-3" to="/login">
                <Button  variant="primary">Clinic Log In</Button>
            </LinkContainer>
            
            </Navbar.Collapse>
            </Navbar>
        </div>
    )
}